export const updatePartner = /* GraphQL */ `
  mutation UpdatePartner(
    $input: UpdatePartnerInput!
    $condition: ModelPartnerConditionInput
  ) {
    updatePartner(input: $input, condition: $condition) {
      id
      name
      display_name
      app_settings {
        components
        dashboard_settings
        challenges
        report_settings
        usedAlgorithm
        hello_text
        custom_data_policy
        notifications {
          webhook
          mail
        }
        assessment_expires_after_days
      }
      logo
      createdAt
      updatedAt
      __typename
    }
  }
`
